import React, { Component } from "react";
import TableC from "../../basicElement/TableC";
import $ from '../../../common/AjaxRequest';
import { DatePicker, Button, Select, message, Tooltip, Icon } from "antd";
import SearchRetrieve from '../../common/SearchRetrieve.new';
import API_URL from "../../../common/url";
import moment from "moment";
import format from "../../shared/format";

const monthFormat = "YYYY-MM";
const { MonthPicker } = DatePicker;
const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {},
        deptList: [],
        positionList: [],
    }

    componentDidMount() {
        this.initializeDate();
        this.getDepartmentList();
    }

    getDepartmentList = () => {
        const options = {
            url: API_URL.dashboard.queryDeptAndPosition,
            data: { type: 'BusinessLine' },
            dataType: 'json',
            doneResult: (res => {
                const { deptList, positionList } = res;
                this.setState({ deptList, positionList });
            }),
        };
        $.sendRequest(options);
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({ ...searchParams });
    };


    handleFilterChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams } });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'user':
                {
                    const { value: id, text: name } = value;
                    searchParams[`${key}Id`] = id;
                    searchParams[`${key}Name`] = name;
                    this.handleFilterChange(searchParams);
                    break;
                }
            default:
                searchParams[key] = value;
                this.handleFilterChange(searchParams);
                break;
        }
        this.setState({ searchParams });
    };

    exportReport = () => {
        const { searchParams } = this.state;
        this.props.export(searchParams);
    }

    initializeDate = () => {
        const { searchParams } = this.state;
        const date = moment().date() < 26 ? moment().add(-1, 'M').format(monthFormat) : moment().format(monthFormat);
        searchParams.begin = date;
        searchParams.end = date;
        this.setState({ searchParams }, () => { this.search() })
    }

    disabledDate = (current, key) => {
        const { searchParams } = this.state;
        const currentValue = current.valueOf();
        if (key == 'begin') {
            return current && (currentValue < moment(searchParams.end).add(-11, 'M') || currentValue > moment(searchParams.end));
        } else {
            return current && (currentValue < moment(searchParams.begin) || currentValue > moment(searchParams.begin).add(11, 'M'));
        }
    };

    render() {
        const { searchParams, deptList = [], positionList = [] } = this.state;
        const { enterpriseDepartmentName, positionName } = searchParams;
        const depOptions = deptList.map(el => <Option value={el}>{el}</Option>);
        const positionOptions = positionList.map(el => <Option value={el}>{el}</Option>);
        return (
            <div>
                <div className="search-bar" style={{marginBottom:'10px',width:'100%'}}>
                    <div className="search-item" >
                        <label className="ui-label" >
                            收入确认时间
                        </label>
                        <MonthPicker
                            format={monthFormat}
                            value={searchParams.begin ? moment(searchParams.begin) : null}
                            onChange={(date, dateString) => this.handleChange(dateString, "begin")}
                            allowClear={false}
                            disabledDate={(current) => this.disabledDate(current, 'begin')}
                            style={{ width: 100, verticalAlign: "middle" }}
                        />
                        <label className="ui-label" style={{ marginLeft: '10px', verticalAlign: "middle" }}>
                            至
                        </label>
                        <MonthPicker
                            format={monthFormat}
                            value={searchParams.end ? moment(searchParams.end) : null}
                            onChange={(date, dateString) => this.handleChange(dateString, "end")}
                            allowClear={false}
                            disabledDate={(current) => this.disabledDate(current, 'end')}
                            style={{ width: 100, verticalAlign: "middle" }}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">员工</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 160 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.userName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'user')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">所属部门</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 160 }}
                            value={enterpriseDepartmentName}
                            onChange={value => this.handleChange(value, 'enterpriseDepartmentName')}
                        >
                            {depOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">职位</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 160 }}
                            value={positionName}
                            onChange={value => this.handleChange(value, 'positionName')}
                        >
                            {positionOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">状态</label>
                        <Select
                            placeholder="请选择"
                            style={{ width: 120 }}
                            value={searchParams.workStatus}
                            allowClear={true}
                            onChange={(value) => this.handleChange(value, "workStatus")}
                        >
                            <Option key={'WORKING'} value={'WORKING'}>在职</Option>
                            <Option key={'LEFT'} value={'LEFT'}>离职</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.exportReport}>导出</Button>
                    </div>
                </div>
            </div>
        );
    }
}

class Business extends Component {
    state = {
        data: [],
        loading: false,
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryBusinessLineIncomeList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                type: 'BusinessLine',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination
                });
            }
        };
        $.sendRequest(options);
    };

    search = searchParams => {
        const { pagination = {} } = this.state;
        pagination.current = 1;
        this.setState({ searchParams, pagination },
            () => {
                this.loadData();
            }
        );
    };

    export = (searchParams) => {
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportBusinessLineIncome,
            data: {
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success)
            }
        };
        $.sendRequest(options);
    };

    getColumns = () => {
        const columns = [
            {
                title: '收入确认时间',
                dataIndex: 'yearMonthNum',
                key: 'yearMonthNum',
                width: 100,
                fixed: 'left',
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 100,
                fixed: 'left',
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 100,
                fixed: 'left',
            }, {
                title: '部门',
                dataIndex: 'enterpriseDepartmentName',
                key: 'enterpriseDepartmentName',
                width: 100,
            }, {
                title: '职位级别',
                dataIndex: 'positionName',
                key: 'positionName',
                width: 100,
                render: (text, record) => {
                    const { positionRed } = record;
                    return <span style={{ color: positionRed ? 'red' : undefined}}>{text}</span>
                }
            }, {
                title: '管理级别',
                dataIndex: 'managerLevel',
                key: 'managerLevel',
                width: 100,
            }, {
                title: '级别（就高）',
                dataIndex: 'levelNum',
                key: 'levelNum',
                width: 100,
            }, {
                title: '状态',
                dataIndex: 'workStatus',
                key: 'workStatus',
                width: 100,
                render: text => text === 'WORKING' ? '在职' : '离职'
            }, {
                title: (
                    <span>
                        工作周期（h）
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'扣除休假类型是病假、事假、产假的工作周期（h）'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'workHour',
                key: 'workHour',
                width: 120,
            }, {
                title: '团队规模',
                dataIndex: 'teamSize',
                key: 'teamSize',
                width: 100,
            }, {
                title: '变动前职位级别',
                dataIndex: 'beforePromotionName',
                key: 'beforePromotionName',
                width: 120,
            }, {
                title: '变动后职位级别',
                dataIndex: 'afterPromotionName',
                key: 'afterPromotionName',
                width: 120,
            }, {
                title: '变动前管理级别',
                dataIndex: 'beforeManagerLevel',
                key: 'beforeManagerLevel',
                width: 120,
            }, {
                title: '变动后管理级别',
                dataIndex: 'afterManagerLevel',
                key: 'afterManagerLevel',
                width: 120,
            }, {
                title: '晋升生效时间',
                dataIndex: 'promotionDateShow',
                key: 'promotionDateShow',
                width: 100,
            }, {
                title: '当月PM收入',
                dataIndex: 'pmIncomeAmount',
                key: 'pmIncomeAmount',
                width: 100,
            }, {
                title: '当月领域leader收入',
                dataIndex: 'talIncomeAmount',
                key: 'talIncomeAmount',
                width: 100,
            }, {
                title: '当月PML收入',
                dataIndex: 'pmlIncomeAmount',
                key: 'pmlIncomeAmount',
                width: 100,
            }, {
                title: '当月业务线负责人收入',
                dataIndex: 'businessLineUserAmount',
                key: 'businessLineUserAmount',
                width: 100,
            }, {
                title: '当月收入底限',
                dataIndex: 'currentMonthBaseLine',
                key: 'currentMonthBaseLine',
                width: 100,
                render: text => format('money', text),
            }, {
                title: 'YTD收入底限',
                dataIndex: 'currentYearBaseLine',
                key: 'currentYearBaseLine',
                width: 100,
                render: text => format('money', text),
            }, {
                title: '当月收入底限（扣假）',
                dataIndex: 'currentMonthBaseLineDeductionVacation',
                key: 'currentMonthBaseLineDeductionVacation',
                width: 100,
                render: text => format('money', text),
            }, {
                title: 'YTD收入底限（扣假）',
                dataIndex: 'currentYearBaseLineDeductionVacation',
                key: 'currentYearBaseLineDeductionVacation',
                width: 100,
                render: text => format('money', text),
            }, {
                title: '当月总收入',
                dataIndex: 'currentMonthAmount',
                key: 'currentMonthAmount',
                width: 100,
                render: text => format('money', text),
            }, {
                title: 'YTD总收入',
                dataIndex: 'currentYearAmount',
                key: 'currentYearAmount',
                width: 100,
                render: text => format('money', text),
            }, {
                title: (
                    <span>
                        YTD比值
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'YTD总收入/YTD收入底限（扣假）'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'currentYearRatioShow',
                key: 'currentYearRatioShow',
                width: 100,
                render: text => text == '-' ? text : `${text}%`,
            }
        ];
        return columns;
    };

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(el => {
            const { promotionDate } = el;
            return {
                ...el,
                promotionDateShow: promotionDate ? moment(promotionDate).format('YYYY-MM-DD') : null
            }
        })
        return dataSource
    }

    render() {
        const {
            loading,
            pagination,
        } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                />
                <TableC
                    data={this.getDataSource()}
                    scrollY={500}
                    loading={loading}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default Business;



// WEBPACK FOOTER //
// ./src/components/financeManagement/IncomeReport/Business.js